<script setup lang="ts">
import TheHeader from "./components/layout/TheHeader.vue";
import TheFooter from "./components/layout/TheFooter.vue";

</script>

<template>
  <the-header></the-header>

  <router-view :key="$route.fullPath"></router-view>

  <router-view name="RightSidebar"></router-view>

  <the-footer></the-footer>
</template>

<style scoped>
</style>
